import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

interface selectType {
  options: any;
  type?: string;
  defaultValue: SelectType | undefined;
  onChangeValue: any;
  width?: number;
  icon?: string;
  disabled?: boolean;
}

export type SelectType = {
  key: number;
  value: any;
  name: string;
  label?: string;
};

const DropdownSelect = ({
  options,
  defaultValue,
  type,
  onChangeValue,
  icon,
  disabled,
}: selectType) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<SelectType>(defaultValue!);
  const selectRef = useRef<HTMLDivElement | null>(null);

  const handleSelectClick = () => {
    if (!disabled) setIsOpen(!isOpen);
    // console.log('isOpen', isOpen);
  };

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
    onChangeValue(option);
    setIsOpen(false);
  };

  const handleOutsideClick = (event: any) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    setSelectedOption(defaultValue!);
  }, [defaultValue]);

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <Style>
      <div className={`selector ${disabled && 'disabled'}`} ref={selectRef}>
        <div className="selectHeader" onClick={handleSelectClick}>
          {selectedOption.name}
          <img
            src={`${process.env.PUBLIC_URL}/svg/${icon ? icon : 'ic_arrow_down_grey'}.svg`}
            width={20}
            height={20}
            alt="ic"
          />
        </div>
        {isOpen && (
          <ul
            className="selectList"
            style={{ height: `${options.length > 6 ? 200 : options.length * 32 + 6}px` }}>
            {options.map((option: SelectType) => (
              <li
                key={option.key}
                onClick={() => handleOptionClick(option)}
                className={`selectItem ${option.value === selectedOption.value && 'selected'}`}>
                {option.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </Style>
  );
};
export default DropdownSelect;

export const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .selector {
    position: relative;
    padding: 8px 10px 8px 20px;
    font-size: 14px;
    line-height: 20px;
    color: #979797;
    border: 1px solid #cecece;
    border-radius: 5px;
    cursor: pointer;
  }
  .selector.disabled {
    background: #e5e5e5;
  }
  .selectHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .arrow {
    color: #979797;
  }
  .arrow.open {
    color: #555555;
    font-weight: 600;
  }

  .selectList {
    width: 100%;
    position: absolute;
    overflow-y: auto;
    z-index: 1;
    top: 21px;
    left: 0;
    padding: 0;
    border-radius: 0px 0px 5px 5px;
    background: #ffffff;
    border: 1px solid #cecece;
    list-style: none;
    animation: expandDown 0.15s ease-out;

    .selectItem {
      padding: 8px 20px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .selectItem:hover {
      background: #ecf5f3;
    }
    .selectItem.selected {
      background: #4dd2ae;
      color: #ffffff;
    }
  }

  @media (max-width: 900px) {
    .selector {
      padding: 8px 5px 8px 10px;
      font-size: 12px;
    }
    .selectList {
      .selectItem {
        padding: 6px 8px;
        font-size: 12px;
        text-align: left;
      }
    }
  }
`;
